import React from 'react';
import {
  ExclamationCircleFilled,
  LockFilled,
  DisconnectOutlined,
} from '@ant-design/icons';
import { ArgsProps } from 'antd/lib/notification';

interface ErrorNotification extends ArgsProps {
  type: 'error' | 'warning' | 'info' | 'success';
}

const errors: { [key: string]: ErrorNotification } = {
  '403': {
    type: 'warning',
    icon: <LockFilled style={{ color: 'orange' }} />,
    message: 'Permission Denied',
    description: "You don't have permission to perform that action.",
  },

  '504': {
    type: 'error',
    icon: <DisconnectOutlined style={{ color: 'red' }} />,
    message: 'Connection Issue',
  },

  default: {
    type: 'error',
    icon: <ExclamationCircleFilled style={{ color: 'red' }} />,
    message: 'Something went wrong',
    description: 'Please contact support if this error persists.',
  },
};

export default errors;
